module.exports = __webpack_public_path__ + "assets/img/favicon.37395dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.png
// module id = 43
// module chunks = 0